import { createApp } from 'vue'
import App from './App.vue'
import VueAwesomePaginate from "vue-awesome-paginate"
import "vue-awesome-paginate/dist/style.css"
import { createI18n } from 'vue-i18n';

const i18n = createI18n({
  locale: getLanguageFromUrl(),
  messages: {
    en: {
      paymentsEnabled: 'Payments Enabled',
      bulkPaymentsEnabled: 'Bulk Payments Enabled',
      accountInfo: 'Account info',
      backButton: 'Back to the map',
      experimental: 'EXPERIMENTAL',
      accountInformation: 'ACCOUNT INFORMATION',
      paymentInitiation: 'PAYMENT INITIATION',
      bulkPayments: 'BULK PAYMENTS',
      country: 'COUNTRY',
      searchInstitutions: 'search institution',
      banksFound: 'banks found',
      allCountries: 'All Countries',
      filteredby: 'Filtered by',
    },
    es: {
      paymentsEnabled: 'Payments Enabled',
      bulkPaymentsEnabled: 'Bulk Payments Enabled',
      accountInfo: 'Account info',
      backButton: 'Volver al mapa',
      experimental: 'EXPERIMENTAL',
      accountInformation: 'ACCOUNT INFORMATION',
      paymentInitiation: 'PAYMENT INITIATION',
      bulkPayments: 'BULK PAYMENTS',
      country: 'COUNTRY',
      searchInstitutions: 'search institution',
      banksFound: 'banks found',
      allCountries: 'All Countries',
      filteredby: 'Filtered by',
    },
    fr: {
      paymentsEnabled: 'Payments Enabled',
      bulkPaymentsEnabled: 'Bulk Payments Enabled',
      accountInfo: 'Account info',
      backButton: 'Retour à la carte',
      experimental: 'EXPÉRIMENTAL',
      accountInformation: 'INFORMATION DE COMPTE',
      paymentInitiation: 'INITIATION DE PAIEMENT',
      bulkPayments: 'PAIEMENTS GROUPÉS',
      country: 'PAYS',
      searchInstitutions: 'Tapez votre recherche',
      banksFound: 'enregistrement(s) trouvé(s)',
      allCountries: 'Tous',
      filteredby: 'Filtered by',
    },
    it: {
      paymentsEnabled: 'Payments Enabled',
      bulkPaymentsEnabled: 'Bulk Payments Enabled',
      accountInfo: 'Account info',
      backButton: 'Torna alla mappa',
      experimental: 'SPERIMENTALE',
      accountInformation: 'INFORMAZIONI ACCOUNT',
      paymentInitiation: 'PAGAMENTO INIZIALE',
      bulkPayments: 'PAGAMENTI MULTIPLI',
      country: 'PAESE',
      searchInstitutions: 'trova per nome',
      banksFound: 'banche trovate',
      allCountries: 'Tutti i paesi',
      filteredby: 'Filtered by',
    },
    nl: {
      paymentsEnabled: 'Payments Enabled',
      bulkPaymentsEnabled: 'Bulk Payments Enabled',
      accountInfo: 'Account info',
      backButton: 'Terug naar kaart',
      experimental: 'EXPERIMENTEEL',
      accountInformation: 'BANKGEGEVENS',
      paymentInitiation: 'BETALING',
      bulkPayments: 'BULKBETALINGEN',
      country: 'LAND',
      searchInstitutions: 'Typ jouw zoekopdracht',
      banksFound: 'record(s) gevonden',
      allCountries: 'Alles',
      filteredby: 'Filtered by',
    },
  }
});

function getLanguageFromUrl() {
  const urlParams = new URLSearchParams(window.location.search);
  const lang = urlParams.get('lang');
  return lang || 'en';
}

createApp(App).use(VueAwesomePaginate).use(i18n).mount("#app");